import { requestPost } from 'utils/request';
import { handleErrors } from '@tcc/scarecrow';

const BASE_URL = '/api/user/public/v2';

export function createPasswordRequest(email, password, token) {
  return requestPost(`${BASE_URL}/credentials/update`, {
    data: JSON.stringify({
      email,
      newpassword: password,
      resetpasswordtoken: token
    })
  }).then(handleErrors);
}
